const formatTranslations = {
  en: {
    Copa: "Glass",
    Jarra: "Jar",
    Botella: "Bottle",
    Lata: "Can",
    Chupito: "Shot",
    Combinado: "Drink",
    "Copa Hielo": "Glass with ice",
  },
  cat: {
    Copa: "Copa",
    Jarra: "Gerra",
    Botella: "Ampolla",
    Lata: "Llauna",
    Chupito: "Xopet",
    Combinado: "Combinat",
    "Copa Hielo": "Copa amb gel",
  },
  fr: {
    Copa: "Verre",
    Jarra: "Pichet",
    Botella: "Bouteille",
    Lata: "Canette",
    Chupito: "Shot",
    Combinado: "Cocktail",
    "Copa Hielo": "Verre avec glace",
  },
};

const familyTranslations = {
  en: {
    "Licores y Destilados": "Liquors and Distillates",
    Alcoholicas: "Alcoholic",
    NoAlcoholicas: "Non-Alcoholic",
    Cervezas: "Beers",
    Vinos: "Wines",
    Blanco: "White",
    Tinto: "Red",
    Rosado: "Rosé",
    Cava: "Sparkling",
    Licor: "Liqueurs",
    Anís: "Anise",
    Aperitivos: "Aperitif",
    Ron: "Rum",
    Refrescos: "Soft Drinks",
  },
  cat: {
    "Licores y Destilados": "Licors i Destil·lats",
    Alcoholicas: "Alcohòliques",
    NoAlcoholicas: "No Alcohòliques",
    Cervezas: "Cerveses",
    Vinos: "Vins",
    Blanco: "Blanc",
    Tinto: "Negre",
    Rosado: "Rosat",
    Cava: "Escumós",
    Licor: "Licors",
    Anís: "Anís",
    Aperitivos: "Aperitius",
    Ron: "Rom",
    Refrescos: "Refrescs",
  },
  fr: {
    "Licores y Destilados": "Liqueurs et Distillats",
    Alcoholicas: "Alcoolisées",
    NoAlcoholicas: "Non Alcoolisées",
    Cervezas: "Bières",
    Vinos: "Vins",
    Blanco: "Blanc",
    Tinto: "Rouge",
    Rosado: "Rosé",
    Cava: "Mousseux",
    Licor: "Liqueurs",
    Anís: "Anis",
    Aperitivos: "Apéritifs",
    Ron: "Rhum",
    Refrescos: "Boissons Gazeuses",
  },
};

export { familyTranslations, formatTranslations };
